import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelSettingsRolesEditResolverErrorStatesEnum {
    GetRoleFailed = ErrorStateScheduleEnum.PanelSettingsRolesEditResolverStatesStartIndex,
    RoleNotFound,
    GetPermissionsFailed,
    PermissionsNotFound
}
